module.exports = __webpack_public_path__ + "static/media/eye.ee770d8e.svg";